import { Routes } from '@angular/router';
import { RouteAccessGuard } from '@app/core/guards/route-access.guard';
import { ChainWideFortigatesComponent } from '@app/features/fortigates/modules/chain-wide-fortigates/chain-wide-fortigates.component';
import { Authority } from '@app/shared/utils/enums';

export const chainWideFortigatesRoutes: Routes = [
    {
        path: 'chain-wide-fortigates',
        children: [
            {
                path: '',
                component: ChainWideFortigatesComponent,
                data: {
                    authorities: [Authority.ADMIN, Authority.UPDATE]
                },
                canActivate: [RouteAccessGuard]
            }
        ]
    }
]